export default __webpack_public_path__ + "static/media/sign-out.f753218e.svg";